"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CharacterSW25 = void 0;
const static_1 = require("./static");
const magic_1 = require("./magic");
const util_1 = require("./util");
class CharacterSW25 {
    constructor() {
        this.pcName = '';
        this.plName = '';
        this.race = '';
        this.url = '';
        this.status = new StatusSW25(0, 0, 0, 0, 0, 0);
        this.level = new LevelJobSW25();
        this.enhances = [];
        this.songs = [];
        this.ridings = [];
        this.alchemies = [];
        this.geomancy = [];
        this.commands = [];
        this.maxHP = 0;
        this.maxMP = 0;
        this.vitResistBase = 0;
        this.mndResistBase = 0;
        this.vitResistAdd = 0;
        this.mndResistAdd = 0;
        this.movilityBasic = 0;
        this.movilityFull = 0;
        this.movilityLimited = 0;
        this.decisionPackage = new DecisionAddPackage();
        this.magicJobs = [];
        this.def = 0;
        this.avoidAdd = 0;
        this.avoidClass = '';
        this.weapons = [];
        this.armourOwn = false;
        this.shieldOwn = false;
        this.combatFeats = [];
        this.chatPalette = [];
        this.paletteInsertType = '';
        this.color = '';
        this.freeHistory = '';
        // アイテム
        this.materialCard = new MaterialCard();
        this.items = new Items([]);
        // TODO 言語
        this.outputOption = {
            addCommandsShortcut: true,
            addCommandsPartition: true,
            noStatus: false,
        };
    }
    // PC名取得
    getPCName() { return this.pcName; }
    static generateInstanceFromYutorize(resYutorize, outputOption) {
        var _a, _b, _c, _d, _e, _f;
        const chara = new CharacterSW25();
        if (!resYutorize) {
            return chara;
        }
        if (!!outputOption) {
            chara.outputOption = outputOption;
        }
        resYutorize = Object.fromEntries(Object.entries(resYutorize).map((entry) => [entry[0], (0, util_1.unescapeHtml)(entry[1])]));
        chara.pcName = resYutorize['characterName'];
        chara.plName = resYutorize['playerName'];
        chara.race = resYutorize['race'];
        chara.url = 'https://yutorize.2-d.jp/ytsheet/sw2.5/?id=' + resYutorize['id'];
        const status = new StatusSW25((0, util_1.string2Int)(resYutorize['sttDex']), (0, util_1.string2Int)(resYutorize['sttAgi']), (0, util_1.string2Int)(resYutorize['sttStr']), (0, util_1.string2Int)(resYutorize['sttVit']), (0, util_1.string2Int)(resYutorize['sttInt']), (0, util_1.string2Int)(resYutorize['sttMnd']));
        status.dexAdd = (0, util_1.string2Int)(resYutorize['sttAddA']);
        status.agiAdd = (0, util_1.string2Int)(resYutorize['sttAddB']);
        status.strAdd = (0, util_1.string2Int)(resYutorize['sttAddC']);
        status.vitAdd = (0, util_1.string2Int)(resYutorize['sttAddD']);
        status.intAdd = (0, util_1.string2Int)(resYutorize['sttAddE']);
        status.mndAdd = (0, util_1.string2Int)(resYutorize['sttAddF']);
        chara.status = status;
        const level = new LevelJobSW25();
        level.adventure = (0, util_1.string2Int)(resYutorize['level']);
        level.fighter = (0, util_1.string2Int)(resYutorize['lvFig']);
        level.grappler = (0, util_1.string2Int)(resYutorize['lvGra']);
        level.battledancer = (0, util_1.string2Int)(resYutorize['lvBat']);
        level.fencer = (0, util_1.string2Int)(resYutorize['lvFen']);
        level.shooter = (0, util_1.string2Int)(resYutorize['lvSho']);
        level.sorcerer = (0, util_1.string2Int)(resYutorize['lvSor']);
        level.conjurer = (0, util_1.string2Int)(resYutorize['lvCon']);
        level.priest = (0, util_1.string2Int)(resYutorize['lvPri']);
        level.fairytamer = (0, util_1.string2Int)(resYutorize['lvFai']);
        level.magitech = (0, util_1.string2Int)(resYutorize['lvMag']);
        level.scout = (0, util_1.string2Int)(resYutorize['lvSco']);
        level.ranger = (0, util_1.string2Int)(resYutorize['lvRan']);
        level.sage = (0, util_1.string2Int)(resYutorize['lvSag']);
        level.enhancer = (0, util_1.string2Int)(resYutorize['lvEnh']);
        level.bard = (0, util_1.string2Int)(resYutorize['lvBar']);
        level.rider = (0, util_1.string2Int)(resYutorize['lvRid']);
        level.alchemist = (0, util_1.string2Int)(resYutorize['lvAlc']);
        level.druid = (0, util_1.string2Int)(resYutorize['lvDru']);
        level.demonruler = (0, util_1.string2Int)(resYutorize['lvDem']);
        level.wizard = (0, util_1.string2Int)(resYutorize['lvWiz']);
        level.geomancer = (0, util_1.string2Int)(resYutorize['lvGeo']);
        level.warleader = (0, util_1.string2Int)(resYutorize['lvWar']);
        level.mystic = (0, util_1.string2Int)(resYutorize['lvMys']);
        level.phigicalmaster = (0, util_1.string2Int)(resYutorize['lvPhy']);
        level.grimoire = (0, util_1.string2Int)(resYutorize['lvGri']);
        level.aristocracy = (0, util_1.string2Int)(resYutorize['lvAri']);
        level.artisan = (0, util_1.string2Int)(resYutorize['lvArt']);
        chara.level = level;
        // 戦闘特技
        const combatFeats = [];
        // バトルダンサー初期取得戦闘技能
        if (!!resYutorize['combatFeatsLv1bat'] && level.battledancer > 0) {
            combatFeats.push(resYutorize['combatFeatsLv1bat']);
        }
        for (let i = 1; i <= level.adventure; i++) {
            if (resYutorize['combatFeatsLv' + i] === undefined) {
                continue;
            }
            combatFeats.push(resYutorize['combatFeatsLv' + i]);
        }
        const combatFeatsAuto = (_a = resYutorize['combatFeatsAuto']) !== null && _a !== void 0 ? _a : '';
        if (combatFeatsAuto !== '') {
            chara.combatFeats = combatFeats.concat(combatFeatsAuto.split(','));
        }
        else {
            chara.combatFeats = combatFeats;
        }
        // 練技
        const enhances = [];
        for (let i = 1; i <= level.enhancer; i++) {
            if (resYutorize['craftEnhance' + i] === undefined) {
                continue;
            }
            enhances.push(resYutorize['craftEnhance' + i]);
            // console.info('craftEnhance'+i);
        }
        chara.enhances = enhances;
        // 呪歌・終律
        const songs = [];
        for (let i = 1; i <= level.bard; i++) {
            if (resYutorize['craftSong' + i] === undefined) {
                continue;
            }
            songs.push(resYutorize['craftSong' + i]);
            // console.info('craftSong'+i);
        }
        chara.songs = songs;
        // 騎芸
        const ridings = [];
        for (let i = 1; i <= level.rider; i++) {
            if (resYutorize['craftRiding' + i] === undefined) {
                continue;
            }
            ridings.push(resYutorize['craftRiding' + i]);
            // console.info('craftRiding'+i);
        }
        chara.ridings = ridings;
        // 賦術
        const alchemies = [];
        for (let i = 1; i <= level.alchemist; i++) {
            if (resYutorize['craftAlchemy' + i] === undefined) {
                continue;
            }
            alchemies.push(resYutorize['craftAlchemy' + i]);
            // console.info('craftAlchemy'+i);
        }
        chara.alchemies = alchemies;
        // 相域
        const geomancy = [];
        for (let i = 1; i <= level.geomancer; i++) {
            if (resYutorize['craftGeomancy' + i] === undefined) {
                continue;
            }
            geomancy.push(resYutorize['craftGeomancy' + i]);
            // console.info('craftGeomancy'+i);
        }
        chara.geomancy = geomancy;
        // 鼓咆
        const commands = [];
        for (let i = 1; i <= level.warleader; i++) {
            if (resYutorize['craftCommand' + i] === undefined) {
                continue;
            }
            commands.push(resYutorize['craftCommand' + i]);
            // console.info('craftCommand'+i);
        }
        chara.commands = commands;
        chara.maxHP = (0, util_1.string2Int)(resYutorize['hpTotal']);
        chara.maxMP = (0, util_1.string2Int)(resYutorize['mpTotal']);
        chara.vitResistBase = (0, util_1.string2Int)(resYutorize['vitResistBase']);
        chara.mndResistBase = (0, util_1.string2Int)(resYutorize['mndResistBase']);
        chara.vitResistAdd = (0, util_1.string2Int)(resYutorize['vitResistAdd']);
        chara.mndResistAdd = (0, util_1.string2Int)(resYutorize['mndResistAdd']);
        chara.movilityBasic = (0, util_1.string2Int)(resYutorize['mobilityTotal']);
        chara.movilityFull = (0, util_1.string2Int)(resYutorize['mobilityFull']);
        chara.movilityLimited = (0, util_1.string2Int)(resYutorize['mobilityLimited']);
        // パッケージ
        const decisionPackage = new DecisionAddPackage();
        decisionPackage.scoutPackage = {
            tec: (0, util_1.string2Int)(resYutorize['packScoTecAdd']),
            agi: (0, util_1.string2Int)(resYutorize['packScoAgiAdd']),
            obs: (0, util_1.string2Int)(resYutorize['packScoObsAdd']),
        };
        decisionPackage.rangerPackage = {
            tec: (0, util_1.string2Int)(resYutorize['packRanTecAdd']),
            agi: (0, util_1.string2Int)(resYutorize['packRanAgiAdd']),
            obs: (0, util_1.string2Int)(resYutorize['packRanObsAdd']),
        };
        decisionPackage.sagePackage = {
            kno: (0, util_1.string2Int)(resYutorize['packSagKnoAdd']),
        };
        decisionPackage.riderPackage = {
            obs: (0, util_1.string2Int)(resYutorize['packRidTecAdd']),
            agi: (0, util_1.string2Int)(resYutorize['packRidAgiAdd']),
            kno: (0, util_1.string2Int)(resYutorize['packRidKnoAdd']),
        };
        decisionPackage.alchemistPackage = {
            kno: (0, util_1.string2Int)(resYutorize['packAlcKnoAdd']),
        };
        decisionPackage.bardPackage = {
            kno: (0, util_1.string2Int)(resYutorize['packBarKnoAdd']),
        };
        decisionPackage.warleaderPackage = {
            agi: (0, util_1.string2Int)(resYutorize['packWarAgiAdd']),
            int: (0, util_1.string2Int)(resYutorize['packWarIntAdd']),
        };
        decisionPackage.monsterLore = (0, util_1.string2Int)(resYutorize['monsterLoreAdd']);
        decisionPackage.initiative = (0, util_1.string2Int)(resYutorize['initiativeAdd']);
        chara.decisionPackage = decisionPackage;
        //魔法
        const magPowerAddCombatFeats = chara.combatFeats.filter(combatFeat => combatFeat === '魔力強化Ⅰ' || combatFeat === '魔力強化Ⅱ');
        let magPowerAdd = 0;
        if (magPowerAddCombatFeats[0] && magPowerAddCombatFeats[0] === '魔力強化Ⅰ')
            magPowerAdd = 1;
        else if (magPowerAddCombatFeats[0] && magPowerAddCombatFeats[0] === '魔力強化Ⅱ')
            magPowerAdd = 2;
        // ソーサラー
        chara.magicJobs.push(new magic_1.MagicJob(static_1.JobLabel.sorcerer, (0, util_1.string2Int)(resYutorize['lvSor']), static_1.StatusLabel.INT, (0, util_1.string2Int)((resYutorize['magicPowerAddSor'])) + (0, util_1.string2Int)((resYutorize['magicPowerAdd'])) + magPowerAdd, (0, util_1.string2Int)((resYutorize['magicCastAddSor'])) + (0, util_1.string2Int)((resYutorize['magicCastAdd'])), (0, util_1.string2Int)((resYutorize['magicDamageAddSor'])) + (0, util_1.string2Int)((resYutorize['magicDamageAdd'])), (0, util_1.string2Int)(resYutorize['magicPowerSor']), resYutorize['magicPowerOwnSor'] === '1'));
        // コンジャラー
        chara.magicJobs.push(new magic_1.MagicJob(static_1.JobLabel.conjurer, (0, util_1.string2Int)(resYutorize['lvCon']), static_1.StatusLabel.INT, (0, util_1.string2Int)((resYutorize['magicPowerAddCon'])) + (0, util_1.string2Int)((resYutorize['magicPowerAdd'])) + magPowerAdd, (0, util_1.string2Int)((resYutorize['magicCastAddCon'])) + (0, util_1.string2Int)((resYutorize['magicCastAdd'])), (0, util_1.string2Int)((resYutorize['magicDamageAddCon'])) + (0, util_1.string2Int)((resYutorize['magicDamageAdd'])), (0, util_1.string2Int)(resYutorize['magicPowerCon']), resYutorize['magicPowerOwnCon'] === '1'));
        // ウィザード
        chara.magicJobs.push(new magic_1.MagicJob(static_1.JobLabel.wizard, Math.min((0, util_1.string2Int)(resYutorize['lvSor']), (0, util_1.string2Int)(resYutorize['lvCon'])), static_1.StatusLabel.INT, (0, util_1.string2Int)((resYutorize['magicPowerAddWiz'])) + (0, util_1.string2Int)((resYutorize['magicPowerAdd'])) + magPowerAdd, (0, util_1.string2Int)((resYutorize['magicCastAddWiz'])) + (0, util_1.string2Int)((resYutorize['magicCastAdd'])), (0, util_1.string2Int)((resYutorize['magicDamageAddWiz'])) + (0, util_1.string2Int)((resYutorize['magicDamageAdd'])), (0, util_1.string2Int)(resYutorize['magicPowerWiz']), resYutorize['magicPowerOwnWiz'] === '1'));
        // プリースト
        chara.magicJobs.push(new magic_1.MagicJob(static_1.JobLabel.priest, (0, util_1.string2Int)(resYutorize['lvPri']), static_1.StatusLabel.INT, (0, util_1.string2Int)((resYutorize['magicPowerAddPri'])) + (0, util_1.string2Int)((resYutorize['magicPowerAdd'])) + magPowerAdd, (0, util_1.string2Int)((resYutorize['magicCastAddPri'])) + (0, util_1.string2Int)((resYutorize['magicCastAdd'])), (0, util_1.string2Int)((resYutorize['magicDamageAddPri'])) + (0, util_1.string2Int)((resYutorize['magicDamageAdd'])), (0, util_1.string2Int)(resYutorize['magicPowerPri']), resYutorize['magicPowerOwnPri'] === '1', (_b = resYutorize['faith']) !== null && _b !== void 0 ? _b : ''));
        // マギテック
        chara.magicJobs.push(new magic_1.MagicJob(static_1.JobLabel.magitech, (0, util_1.string2Int)(resYutorize['lvMag']), static_1.StatusLabel.INT, (0, util_1.string2Int)((resYutorize['magicPowerAddMag'])) + (0, util_1.string2Int)((resYutorize['magicPowerAdd'])) + magPowerAdd, (0, util_1.string2Int)((resYutorize['magicCastAddMag'])) + (0, util_1.string2Int)((resYutorize['magicCastAdd'])), (0, util_1.string2Int)((resYutorize['magicDamageAddMag'])) + (0, util_1.string2Int)((resYutorize['magicDamageAdd'])), (0, util_1.string2Int)(resYutorize['magicPowerMag']), resYutorize['magicPowerOwnMag'] === '1'));
        // フェアリーテイマー
        chara.magicJobs.push(new magic_1.MagicJob(static_1.JobLabel.fairytamer, (0, util_1.string2Int)(resYutorize['lvFai']), static_1.StatusLabel.INT, (0, util_1.string2Int)((resYutorize['magicPowerAddFai'])) + (0, util_1.string2Int)((resYutorize['magicPowerAdd'])) + magPowerAdd, (0, util_1.string2Int)((resYutorize['magicCastAddFai'])) + (0, util_1.string2Int)((resYutorize['magicCastAdd'])), (0, util_1.string2Int)((resYutorize['magicDamageAddFai'])) + (0, util_1.string2Int)((resYutorize['magicDamageAdd'])), (0, util_1.string2Int)(resYutorize['magicPowerFai']), resYutorize['magicPowerOwnFai'] === '1'));
        // ドルイド
        chara.magicJobs.push(new magic_1.MagicJob(static_1.JobLabel.druid, (0, util_1.string2Int)(resYutorize['lvDru']), static_1.StatusLabel.INT, (0, util_1.string2Int)((resYutorize['magicPowerAddDru'])) + (0, util_1.string2Int)((resYutorize['magicPowerAdd'])) + magPowerAdd, (0, util_1.string2Int)((resYutorize['magicCastAddDru'])) + (0, util_1.string2Int)((resYutorize['magicCastAdd'])), (0, util_1.string2Int)((resYutorize['magicDamageAddDru'])) + (0, util_1.string2Int)((resYutorize['magicDamageAdd'])), (0, util_1.string2Int)(resYutorize['magicPowerDru']), resYutorize['magicPowerOwnDru'] === '1'));
        // デーモンルーラー
        chara.magicJobs.push(new magic_1.MagicJob(static_1.JobLabel.demonruler, (0, util_1.string2Int)(resYutorize['lvDem']), static_1.StatusLabel.INT, (0, util_1.string2Int)((resYutorize['magicPowerAddDem'])) + (0, util_1.string2Int)((resYutorize['magicPowerAdd'])) + magPowerAdd, (0, util_1.string2Int)((resYutorize['magicCastAddDem'])) + (0, util_1.string2Int)((resYutorize['magicCastAdd'])), (0, util_1.string2Int)((resYutorize['magicDamageAddDem'])) + (0, util_1.string2Int)((resYutorize['magicDamageAdd'])), (0, util_1.string2Int)(resYutorize['magicPowerDem']), resYutorize['magicPowerOwnDem'] === '1'));
        // バード
        chara.magicJobs.push(new magic_1.MagicJob(static_1.JobLabel.bard, (0, util_1.string2Int)(resYutorize['lvBar']), static_1.StatusLabel.MND, (0, util_1.string2Int)(resYutorize['magicPowerAddBar']), (0, util_1.string2Int)(resYutorize['magicCastAddBar']), (0, util_1.string2Int)(resYutorize['magicDamageAddBar']), (0, util_1.string2Int)(resYutorize['magicPowerBar']), resYutorize['magicPowerOwnBar'] === '1'));
        // アルケミスト
        chara.magicJobs.push(new magic_1.MagicJob(static_1.JobLabel.alchemist, (0, util_1.string2Int)(resYutorize['lvAlc']), static_1.StatusLabel.INT, 0, (0, util_1.string2Int)((resYutorize['magicCastAddAlc'])) + (0, util_1.string2Int)((resYutorize['magicCastAdd'])), 0, (0, util_1.string2Int)(resYutorize['magicPowerAlc']), resYutorize['magicPowerOwnAlc'] === '1'));
        // 武器
        const weapons = [];
        const weaponNum = (0, util_1.string2Int)(resYutorize['weaponNum']);
        for (let i = 1; i <= weaponNum; i++) {
            if (!resYutorize['weapon' + i + 'Name'])
                continue; // 武器名無し
            if (resYutorize['weapon' + i + 'Class'] === '自動計算しない')
                continue; // 自動計算しない場合はチャパレ必要ないので武器登録しない
            const weapon = new Weapon();
            weapon.name = resYutorize['weapon' + i + 'Name'];
            weapon.usage = resYutorize['weapon' + i + 'Usage'];
            weapon.reqstr = (0, util_1.string2Int)(resYutorize['weapon' + i + 'Reqd']);
            weapon.acc = (0, util_1.string2Int)(resYutorize['weapon' + i + 'Acc']);
            weapon.rate = (0, util_1.string2Int)(resYutorize['weapon' + i + 'Rate']);
            weapon.crit = (0, util_1.string2Int)((_c = resYutorize['weapon' + i + 'Crit']) !== null && _c !== void 0 ? _c : 10);
            weapon.dmg = (0, util_1.string2Int)(resYutorize['weapon' + i + 'Dmg']);
            weapon.category = resYutorize['weapon' + i + 'Category'];
            weapon.cls = resYutorize['weapon' + i + 'Class'];
            weapon.own = resYutorize['weapon' + i + 'Own'] === '1';
            weapon.accTotal = (0, util_1.string2Int)(resYutorize['weapon' + i + 'AccTotal']);
            weapon.dmgTotal = (0, util_1.string2Int)(resYutorize['weapon' + i + 'DmgTotal']);
            weapons.push(weapon);
        }
        chara.weapons = weapons;
        chara.def = (0, util_1.string2Int)(resYutorize['defenseTotalAllDef']);
        let avoidAdd = 0;
        // 鎧
        for (let i = 1;; i++) {
            if (resYutorize['armour' + i + 'Name'] === undefined) {
                break;
            }
            avoidAdd += (0, util_1.string2Int)(resYutorize['armour' + i + 'Eva']);
            if (!chara.armourOwn) {
                chara.armourOwn = resYutorize['armour' + i + 'Own'] === '1' ? true : false;
            }
        }
        // // 盾
        // for(let i = 1 ;; i++) {
        //   if(resYutorize['shield'+i+'Name'] === undefined) { break; }
        //   avoidAdd += string2Int(resYutorize['shield'+i+'Eva']);
        //   if(!chara.shieldOwn) {
        //     chara.shieldOwn = resYutorize['shield'+i+'Own'] === '1' ? true : false;
        //   }
        // }
        // // 他1,2,3
        // for(let i = 1 ;; i++) {
        //   if(resYutorize['defOther'+i+'Name'] === undefined) { break; }
        //   avoidAdd += string2Int(resYutorize['defOther'+i+'Eva']);
        // }
        chara.avoidAdd = avoidAdd;
        chara.avoidClass = (_d = resYutorize['evasionClass']) !== null && _d !== void 0 ? _d : '';
        // マテリアルカード
        chara.materialCard.red.ss = (0, util_1.string2Int)(resYutorize['cardRedSS']);
        chara.materialCard.red.s = (0, util_1.string2Int)(resYutorize['cardRedS']);
        chara.materialCard.red.a = (0, util_1.string2Int)(resYutorize['cardRedA']);
        chara.materialCard.red.b = (0, util_1.string2Int)(resYutorize['cardRedB']);
        chara.materialCard.green.ss = (0, util_1.string2Int)(resYutorize['cardGreSS']);
        chara.materialCard.green.s = (0, util_1.string2Int)(resYutorize['cardGreS']);
        chara.materialCard.green.a = (0, util_1.string2Int)(resYutorize['cardGreA']);
        chara.materialCard.green.b = (0, util_1.string2Int)(resYutorize['cardGreB']);
        chara.materialCard.black.ss = (0, util_1.string2Int)(resYutorize['cardBlaSS']);
        chara.materialCard.black.s = (0, util_1.string2Int)(resYutorize['cardBlaS']);
        chara.materialCard.black.a = (0, util_1.string2Int)(resYutorize['cardBlaA']);
        chara.materialCard.black.b = (0, util_1.string2Int)(resYutorize['cardBlaB']);
        chara.materialCard.white.ss = (0, util_1.string2Int)(resYutorize['cardWhiSS']);
        chara.materialCard.white.s = (0, util_1.string2Int)(resYutorize['cardWhiS']);
        chara.materialCard.white.a = (0, util_1.string2Int)(resYutorize['cardWhiA']);
        chara.materialCard.white.b = (0, util_1.string2Int)(resYutorize['cardWhiB']);
        chara.materialCard.gold.ss = (0, util_1.string2Int)(resYutorize['cardGolSS']);
        chara.materialCard.gold.s = (0, util_1.string2Int)(resYutorize['cardGolS']);
        chara.materialCard.gold.a = (0, util_1.string2Int)(resYutorize['cardGolA']);
        chara.materialCard.gold.b = (0, util_1.string2Int)(resYutorize['cardGolB']);
        // アイテム
        if (!!resYutorize['items']) {
            chara.items = Item.convertItemsFromYutorizeTable(resYutorize['items']);
        }
        // 履歴（自由記入）
        chara.freeHistory = (_e = resYutorize['freeHistory']) !== null && _e !== void 0 ? _e : '';
        // チャットパレット
        const chatPalette = (_f = resYutorize['chatPalette']) !== null && _f !== void 0 ? _f : '';
        chara.chatPalette = chatPalette.split('<br>');
        chara.paletteInsertType = resYutorize['paletteInsertType'];
        // カラー
        const colorH = parseInt(resYutorize['colorHeadBgH']);
        const colorS = parseInt(resYutorize['colorHeadBgS']);
        const colorL = parseInt(resYutorize['colorHeadBgL']);
        const rgb = (0, util_1.hsl2rgb)(colorH, colorL, colorS);
        chara.color = (0, util_1.rgb2hex)(rgb) === '#080f26' ? '#888888' : (0, util_1.rgb2hex)(rgb);
        return chara;
    }
    generateCCFOLIA() {
        let status = [
            {
                label: 'HP',
                value: this.maxHP,
                max: this.maxHP,
            },
            {
                label: 'MP',
                value: this.maxMP,
                max: this.maxMP,
            },
            {
                label: '防護点',
                value: this.def,
                max: this.def,
            },
            {
                label: '1ゾロ',
                value: 0,
                max: 0,
            },
        ];
        status = status.concat(this.generateAdditionalStatus()); // 追加ステータス
        let params = [];
        if (!this.outputOption.noStatus) {
            params = params.concat(this.level.generateParams()); // 技能
            params = params.concat(this.status.generateParams()); // ステータス
            params = params.concat(this.generateParamsBuff()); // バフ・デバフ
        }
        params = params.concat(this.materialCard.generateParams()); // マテリアルカード
        params = params.concat(this.items.generateParams()); // アイテム
        let commands = '';
        if (this.paletteInsertType === 'exchange') {
            if (this.chatPalette.join('') === '')
                commands += this.generateCommands();
            commands += this.chatPalette.join('\n');
        }
        else if (this.paletteInsertType === 'begin') {
            commands += this.chatPalette.join('\n');
            commands += '\n\n';
            commands += this.generateCommands();
        }
        else if (this.paletteInsertType === 'end') {
            commands += this.generateCommands();
            commands += '\n\n';
            commands += this.chatPalette.join('\n');
        }
        const clipboardData = { kind: 'character', data: {} };
        clipboardData.data = {
            name: this.pcName,
            memo: '',
            initiative: 0,
            externalUrl: this.url,
            status: status,
            params: params,
            iconUrl: null,
            faces: [],
            x: 0,
            y: 0,
            angle: 0,
            width: 4,
            height: 4,
            active: false,
            secret: false,
            invisible: false,
            hideStatus: false,
            color: this.color,
            commands: commands,
            owner: null
        };
        return JSON.stringify(clipboardData);
    }
    generateParamsBuff() {
        const params = [
            {
                label: '《バフ・デバフ》',
                value: '',
            },
            {
                label: static_1.BuffLabel.ALL,
                value: '0',
            },
            {
                label: static_1.BuffLabel.ACT,
                value: '0',
            },
            {
                label: static_1.BuffLabel.ACC,
                value: '0',
            },
            {
                label: static_1.BuffLabel.AVO,
                value: '0',
            },
            {
                label: static_1.BuffLabel.MAG_POWER,
                value: '0',
            },
            {
                label: static_1.BuffLabel.MAG_CAST,
                value: '0',
            },
            {
                label: static_1.BuffLabel.VIT_RESIST,
                value: '0',
            },
            {
                label: static_1.BuffLabel.MND_RESIST,
                value: '0',
            },
            {
                label: static_1.BuffLabel.PHG_DAMAGE,
                value: '0',
            },
            {
                label: static_1.BuffLabel.MAG_DAMAGE,
                value: '0',
            },
            // {
            //   label: BuffLabel.PHG_CRITCAL,
            //   value: '0',
            // },
            // {
            //   label: BuffLabel.MAG_CRITCAL,
            //   value: '0',
            // },
        ];
        return params;
    }
    generateCommands() {
        let commands = [];
        // よく使う定数
        const STATUS_DEX = `${static_1.StatusLabel.DEX}`;
        const STATUS_AGI = `${static_1.StatusLabel.AGI}`;
        const STATUS_STR = `${static_1.StatusLabel.STR}`;
        const STATUS_VIT = `${static_1.StatusLabel.VIT}`;
        const STATUS_INT = `${static_1.StatusLabel.INT}`;
        const STATUS_MND = `${static_1.StatusLabel.MND}`;
        const AVOIDING_BOOST_1 = '回避行動Ⅰ';
        const AVOIDING_BOOST_2 = '回避行動Ⅱ';
        const AVOIDING_SHOOTER = '射手の体術';
        // 巻き込まれ
        commands.push('1d>=4 【巻き込まれ】');
        if (this.outputOption.addCommandsPartition)
            commands.push((0, util_1.generateCommandsPartition)('抵抗・回避系'));
        // 抵抗
        // if(this.outputOption.addCommandsShortcut) {
        //   commands.push(`2d+{${JobLabel.adventure}}+((${STATUS_VIT})/6)+${this.vitResistAdd}+{${BuffLabel.VIT_RESIST}}+{${BuffLabel.ALL}} 【生命抵抗判定】@${CommandShortcut.DEFENCE}`);
        //   commands.push(`2d+{${JobLabel.adventure}}+((${STATUS_MND})/6)+${this.mndResistAdd}+{${BuffLabel.MND_RESIST}}+{${BuffLabel.ALL}} 【精神抵抗判定】@${CommandShortcut.DEFENCE}`);
        //   commands.push(`2d+{${JobLabel.adventure}}+((${STATUS_VIT})/6)+{${BuffLabel.ALL}} 【生死判定】@${CommandShortcut.DEFENCE}`);
        // } else {
        //   commands.push(`2d+{${JobLabel.adventure}}+((${STATUS_VIT})/6)+${this.vitResistAdd}+{${BuffLabel.VIT_RESIST}}+{${BuffLabel.ALL}} 【生命抵抗判定】`);
        //   commands.push(`2d+{${JobLabel.adventure}}+((${STATUS_MND})/6)+${this.mndResistAdd}+{${BuffLabel.MND_RESIST}}+{${BuffLabel.ALL}} 【精神抵抗判定】`);
        //   commands.push(`2d+{${JobLabel.adventure}}+((${STATUS_VIT})/6)+{${BuffLabel.ALL}} 【生死判定】`);
        // }
        const resistsCommands = this.convertCommandsResists({
            addCommandsShortcut: this.outputOption.addCommandsShortcut,
            noStatus: this.outputOption.noStatus,
        });
        commands = commands.concat(resistsCommands);
        // 回避
        let avoidBoost = 0;
        if (this.combatFeats.some(elem => elem === AVOIDING_BOOST_1))
            avoidBoost = 1;
        else if (this.combatFeats.some(elem => elem === AVOIDING_BOOST_2))
            avoidBoost = 2;
        if (this.outputOption.addCommandsShortcut) {
            commands.push(this.convertCommandAvoiding(this.avoidClass, this.avoidAdd + avoidBoost, STATUS_AGI, `【回避判定】`, `${static_1.CommandShortcut.DEFENCE}`, this.shieldOwn));
        }
        else {
            commands.push(this.convertCommandAvoiding(this.avoidClass, this.avoidAdd + avoidBoost, STATUS_AGI, `【回避判定】`, ``, this.shieldOwn));
        }
        if (this.outputOption.addCommandsPartition
            && this.weapons.length > 0) {
            commands.push((0, util_1.generateCommandsPartition)('武器攻撃系'));
        }
        // 武器
        this.weapons.forEach(weapon => {
            if (this.outputOption.addCommandsShortcut) {
                commands.push(`> ${weapon.getUsageAndName()}で攻撃@${static_1.CommandShortcut.ATTACK}`);
            }
            else {
                commands.push(`> ${weapon.getUsageAndName()}で攻撃`);
            }
            commands.push(weapon.convertCommandsAccracy(this.combatFeats, this.outputOption.addCommandsShortcut, this.outputOption.noStatus));
            commands = commands.concat(weapon.convertCommandsDamage(this.combatFeats, this.outputOption.addCommandsShortcut, this.outputOption.noStatus));
        });
        // console.info(commands);
        if (this.outputOption.addCommandsPartition
            && this.magicJobs.filter(job => job.level > 0).length > 0) {
            commands.push((0, util_1.generateCommandsPartition)('魔法・行使系'));
        }
        // 魔法
        this.magicJobs.filter(job => job.level > 0)
            .sort((jobA, jobB) => jobB.level - jobA.level)
            .forEach(job => {
            commands.push(job.convertCommandCast({
                addCommandsShortcut: this.outputOption.addCommandsShortcut,
                noStatus: this.outputOption.noStatus,
            }));
            if (this.combatFeats.some(combatFeat => combatFeat === '終律増強')
                && job.name === static_1.JobLabel.bard) {
                job.getMagicRates().forEach(magicRates => {
                    commands = commands.concat(job.convertCommandsDamage({
                        rates: magicRates.rates.map(rate => rate + 10),
                        jobLabel: job.name,
                        isHeal: magicRates.type === 'heal',
                        addCommandsShortcut: this.outputOption.addCommandsShortcut,
                        noStatus: this.outputOption.noStatus,
                    }));
                });
            }
            else {
                job.getMagicRates().forEach(magicRates => {
                    commands = commands.concat(job.convertCommandsDamage({
                        rates: magicRates.rates,
                        jobLabel: job.name,
                        isHeal: magicRates.type === 'heal',
                        addCommandsShortcut: this.outputOption.addCommandsShortcut,
                        noStatus: this.outputOption.noStatus,
                    }));
                });
            }
        });
        // console.info(commands);
        if (this.outputOption.addCommandsPartition)
            commands.push((0, util_1.generateCommandsPartition)('冒険者技能系'));
        // 冒険者〇〇
        const advShortcut = this.outputOption.addCommandsShortcut ? `adv` : ``;
        commands.push(this.convertCommandBasic(static_1.JobLabel.adventure, 0, STATUS_DEX, `【冒険者器用】`, advShortcut));
        commands.push(this.convertCommandBasic(static_1.JobLabel.adventure, 0, STATUS_AGI, `【冒険者敏捷】`, advShortcut));
        commands.push(this.convertCommandBasic(static_1.JobLabel.adventure, 0, STATUS_STR, `【冒険者筋力】`, advShortcut));
        commands.push(this.convertCommandBasic(static_1.JobLabel.adventure, 0, STATUS_INT, `【冒険者知力】`, advShortcut));
        if (this.outputOption.addCommandsPartition
            && (this.level.scout > 0
                || this.level.ranger > 0
                || this.level.sage > 0
                || this.level.bard > 0
                || this.level.alchemist > 0
                || this.level.rider > 0
                || this.level.demonruler > 0
                || this.level.geomancer > 0)) {
            commands.push((0, util_1.generateCommandsPartition)('探索判定系'));
        }
        if (this.level.scout > 0) {
            // スカウト
            const scoutShortcut = this.outputOption.addCommandsShortcut ? `scout` : ``;
            commands.push(this.convertCommandBasic(static_1.JobLabel.scout, this.decisionPackage.scoutPackage.tec, STATUS_DEX, `【スカウト技巧判定】`, scoutShortcut));
            commands.push(this.convertCommandBasic(static_1.JobLabel.scout, this.decisionPackage.scoutPackage.agi, STATUS_AGI, `【スカウト運動判定】`, scoutShortcut));
            commands.push(this.convertCommandBasic(static_1.JobLabel.scout, this.decisionPackage.scoutPackage.obs, STATUS_INT, `【スカウト観察判定】`, scoutShortcut));
        }
        if (this.level.ranger > 0) {
            // レンジャー
            const rangerShortcut = this.outputOption.addCommandsShortcut ? `ranger` : ``;
            commands.push(this.convertCommandBasic(static_1.JobLabel.ranger, this.decisionPackage.rangerPackage.tec, STATUS_DEX, `【レンジャー技巧判定】`, rangerShortcut));
            commands.push(this.convertCommandBasic(static_1.JobLabel.ranger, this.decisionPackage.rangerPackage.agi, STATUS_AGI, `【レンジャー運動判定】`, rangerShortcut));
            commands.push(this.convertCommandBasic(static_1.JobLabel.ranger, this.decisionPackage.rangerPackage.obs, STATUS_INT, `【レンジャー観察判定】`, rangerShortcut));
        }
        if (this.level.sage > 0) {
            // セージ
            const sageShortcut = this.outputOption.addCommandsShortcut ? `sage` : ``;
            commands.push(this.convertCommandBasic(static_1.JobLabel.sage, this.decisionPackage.sagePackage.kno, STATUS_INT, `【セージ知識判定】`, sageShortcut));
        }
        if (this.level.bard > 0) {
            // バード
            const bardShortcut = this.outputOption.addCommandsShortcut ? `bard` : ``;
            commands.push(this.convertCommandBasic(static_1.JobLabel.bard, this.decisionPackage.bardPackage.kno, STATUS_INT, `【バード知識判定】`, bardShortcut));
        }
        if (this.level.alchemist > 0) {
            // アルケミスト
            const alchemistShortcut = this.outputOption.addCommandsShortcut ? `alchemist` : ``;
            commands.push(this.convertCommandBasic(static_1.JobLabel.alchemist, this.decisionPackage.alchemistPackage.kno, STATUS_INT, `【アルケミスト知識判定】`, alchemistShortcut));
        }
        if (this.level.rider > 0) {
            // ライダー
            const riderShortcut = this.outputOption.addCommandsShortcut ? `rider` : ``;
            commands.push(this.convertCommandBasic(static_1.JobLabel.rider, this.decisionPackage.riderPackage.agi, STATUS_AGI, `【ライダー運動判定】`, riderShortcut));
            commands.push(this.convertCommandBasic(static_1.JobLabel.rider, this.decisionPackage.riderPackage.obs, STATUS_INT, `【ライダー観察判定】`, riderShortcut));
            commands.push(this.convertCommandBasic(static_1.JobLabel.rider, this.decisionPackage.riderPackage.kno, STATUS_INT, `【ライダー知識判定】`, riderShortcut));
        }
        if (this.level.demonruler > 0) {
            // デーモンルーラー
            const demonrulerShortcut = this.outputOption.addCommandsShortcut ? `demon` : ``;
            commands.push(this.convertCommandBasic(static_1.JobLabel.demonruler, 0, STATUS_INT, `【送還判定】`, demonrulerShortcut));
        }
        if (this.level.geomancer > 0) {
            // ジオマンサー
            const geomancerShortcut = this.outputOption.addCommandsShortcut ? `geomancer` : ``;
            commands.push(this.convertCommandBasic(static_1.JobLabel.geomancer, this.decisionPackage.geomancerPackage.obs, STATUS_INT, `【ジオマンサー観察判定】`, geomancerShortcut));
        }
        if (this.outputOption.addCommandsPartition
            && (this.level.scout > 0
                || this.level.warleader > 0
                || this.level.sage > 0
                || this.level.rider > 0)) {
            commands.push((0, util_1.generateCommandsPartition)('戦闘準備系'));
        }
        // 先制判定
        const initiativeShortcut = this.outputOption.addCommandsShortcut ? static_1.CommandShortcut.INITIATIVE : ``;
        if (this.level.scout > 0)
            commands.push(this.convertCommandBasic(static_1.JobLabel.scout, this.decisionPackage.initiative, STATUS_AGI, `【先制判定（スカウト）】`, initiativeShortcut));
        if (this.level.warleader > 0)
            commands.push(this.convertCommandBasic(static_1.JobLabel.warleader, this.decisionPackage.warleaderPackage.agi, STATUS_AGI, `【先制判定（ウォーリーダー）】`, initiativeShortcut));
        if (this.level.warleader > 0)
            commands.push(this.convertCommandBasic(static_1.JobLabel.warleader, this.decisionPackage.warleaderPackage.int + 1, STATUS_INT, `【先制判定（ウォーリーダー知力）】`, initiativeShortcut));
        // 魔物知識判定
        const monsterShortcut = this.outputOption.addCommandsShortcut ? static_1.CommandShortcut.MONSTER : ``;
        if (this.level.sage > 0)
            commands.push(this.convertCommandBasic(static_1.JobLabel.sage, this.decisionPackage.monsterLore, STATUS_INT, `【魔物知識判定（セージ）】`, monsterShortcut));
        if (this.level.rider > 0)
            commands.push(this.convertCommandBasic(static_1.JobLabel.rider, this.decisionPackage.monsterLore, STATUS_INT, `【魔物知識判定（ライダー）】`, monsterShortcut));
        if (this.level.rider > 0)
            commands.push(this.convertCommandBasic(static_1.JobLabel.rider, this.decisionPackage.monsterLore, STATUS_INT, `【弱点隠蔽判定】`, monsterShortcut));
        if (this.outputOption.addCommandsPartition)
            commands.push((0, util_1.generateCommandsPartition)('発動宣言系'));
        // 戦闘特技一覧
        this.combatFeats.forEach(combatFeat => {
            if (this.outputOption.addCommandsShortcut) {
                commands.push(`《${combatFeat}》@${static_1.CommandShortcut.SKILL}`);
            }
            else {
                commands.push(`《${combatFeat}》`);
            }
        });
        // 練技
        this.enhances.forEach(enhance => {
            if (this.outputOption.addCommandsShortcut) {
                commands.push(`>>【${enhance}】@${static_1.CommandShortcut.ENHANCE}`);
            }
            else {
                commands.push(`>>【${enhance}】`);
            }
        });
        // 呪歌・終律
        this.songs.forEach(song => {
            if (this.outputOption.addCommandsShortcut) {
                commands.push(`>【${song}】@${static_1.CommandShortcut.SONG}`);
            }
            else {
                commands.push(`>【${song}】`);
            }
        });
        // 騎芸
        this.ridings.forEach(riding => {
            if (this.outputOption.addCommandsShortcut) {
                commands.push(`【${riding}】@${static_1.CommandShortcut.RIDING}`);
            }
            else {
                commands.push(`【${riding}】`);
            }
        });
        // 賦術
        this.alchemies.forEach(alchemie => {
            if (this.outputOption.addCommandsShortcut) {
                commands.push(`>>【${alchemie}】Rank @${static_1.CommandShortcut.ALCHEMY}`);
            }
            else {
                commands.push(`>>【${alchemie}】Rank `);
            }
        });
        // 相域
        this.geomancy.forEach(geomancy => {
            if (this.outputOption.addCommandsShortcut) {
                commands.push(`>>【${geomancy}】@${static_1.CommandShortcut.GEOMANCY}`);
            }
            else {
                commands.push(`>>【${geomancy}】`);
            }
        });
        // 鼓咆・陣率
        this.commands.forEach(command => {
            if (this.outputOption.addCommandsShortcut) {
                commands.push(`>>【${command}】@${static_1.CommandShortcut.COMMAND}`);
            }
            else {
                commands.push(`>>【${command}】`);
            }
        });
        // 魔法一覧
        this.magicJobs.filter(job => job.level > 0)
            .sort((jobA, jobB) => jobB.level - jobA.level)
            .forEach(job => {
            job.magics.forEach(magic => commands.push(magic.convertCommand()));
        });
        if (this.outputOption.addCommandsPartition
            && this.level.ranger > 0) {
            commands.push((0, util_1.generateCommandsPartition)('アイテム系'));
        }
        // アイテム
        if (this.level.ranger > 0) {
            commands = commands.concat(this.convertCommandsItem());
        }
        return commands.join('\n');
    }
    convertCommandBasic(job, add, status, description, shortcut, // ショートカット(@は必要なし)
    isAct = true) {
        const BUFF_ALL = '{' + static_1.BuffLabel.ALL + '}';
        const BUFF_ACT = '{' + static_1.BuffLabel.ACT + '}';
        const command = [];
        command.push('2d');
        if (this.outputOption.noStatus) {
            let num = 0;
            num += this.level.getLevelFromJobLabel(job);
            num += this.status.getStatusBonusValue(status);
            command.push(num.toString());
            if (!!add)
                command.push(add.toString());
        }
        else {
            command.push(`{${job}}`);
            command.push(`(({${status}})/6)`);
            if (!!add)
                command.push(add.toString());
            if (isAct)
                command.push(BUFF_ACT);
            command.push(BUFF_ALL);
        }
        if (!!shortcut) {
            return command.join('+') + ` ${description} @${shortcut}`;
        }
        else {
            return command.join('+') + ` ${description}`;
        }
    }
    convertCommandAvoiding(job, add, status, description, shortcut, isOwn = false) {
        const BUFF_ALL = `{${static_1.BuffLabel.ALL}}`;
        const BUFF_ACT = `{${static_1.BuffLabel.ACT}}`;
        const BUFF_AVO = `{${static_1.BuffLabel.AVO}}`;
        const command = [];
        command.push('2d');
        if (this.outputOption.noStatus) {
            if (job !== '') {
                let avoidNum = 0;
                avoidNum += this.level.getLevelFromJobLabel(job);
                if (isOwn)
                    avoidNum += Math.floor((this.status.getStatusFromLabel(static_1.StatusLabel.AGI) + 2) / 6);
                else
                    avoidNum += Math.floor((this.status.getStatusFromLabel(static_1.StatusLabel.AGI)) / 6);
                ;
                command.push(avoidNum.toString());
            }
            if (!!add)
                command.push(add.toString());
        }
        else {
            if (job !== '') {
                command.push(`{${job}}`);
                if (isOwn)
                    command.push(`(({${status}}+2)/6)`);
                else
                    command.push(`(({${status}})/6)`);
            }
            if (!!add)
                command.push(add.toString());
            command.push(BUFF_AVO);
            command.push(BUFF_ACT);
            command.push(BUFF_ALL);
        }
        if (!!shortcut) {
            return `${command.join('+').replace('+-', '-')} ${description}@${shortcut}`;
        }
        else {
            return `${command.join('+').replace('+-', '-')} ${description}`;
        }
    }
    convertCommandsItem() {
        const STATUS_DEX = '{' + static_1.StatusLabel.DEX + '}';
        const STATUS_INT = '{' + static_1.StatusLabel.INT + '}';
        const commands = [];
        const HERB_RATES = [0, 10, 50];
        const POTION_RATES = [20, 30];
        // 薬草
        HERB_RATES.forEach(rate => {
            const command = [];
            command.push(`k${rate}[13]`);
            if (this.outputOption.noStatus) {
                let num = 0;
                num += this.level.getLevelFromJobLabel(static_1.JobLabel.ranger);
                num += this.status.getStatusBonusValue(static_1.StatusLabel.DEX);
                command.push(num.toString());
            }
            else {
                command.push(`{${static_1.JobLabel.ranger}}`);
                command.push(`((${STATUS_DEX})/6)`);
            }
            if (this.outputOption.addCommandsShortcut) {
                commands.push(`${command.join('+')} 【薬草/威力${rate}】@${static_1.CommandShortcut.ITEM}`);
            }
            else {
                commands.push(`${command.join('+')} 【薬草/威力${rate}】`);
            }
        });
        // // 薬師道具セット
        // HERB_RATES.forEach(rate => {
        //   const command :string[] = [];
        //   command.push('k'+rate+'sf4'+'[13]');
        //   command.push('{'+JobLabel.ranger+'}')
        //   command.push('(('+STATUS_DEX+')/6)');
        //   commands.push(`${command.join('+')} 【薬草/威力${rate}（薬師道具セット）】@${CommandShortcut.ITEM}`);
        // });
        // ポーション
        POTION_RATES.forEach(rate => {
            const command = [];
            command.push(`k${rate}[13]`);
            if (this.outputOption.noStatus) {
                let num = 0;
                num += this.level.getLevelFromJobLabel(static_1.JobLabel.ranger);
                num += this.status.getStatusBonusValue(static_1.StatusLabel.INT);
                command.push(num.toString());
            }
            else {
                command.push(`{${static_1.JobLabel.ranger}}`);
                command.push(`((${STATUS_INT})/6)`);
            }
            if (this.outputOption.addCommandsShortcut) {
                commands.push(`${command.join('+')} 【ポーション/威力${rate}】@${static_1.CommandShortcut.ITEM}`);
            }
            else {
                commands.push(`${command.join('+')} 【ポーション/威力${rate}】`);
            }
        });
        return commands;
    }
    generateAdditionalStatus() {
        // 整形
        let freeHistoryRows = this.freeHistory.split('<br>');
        // |アイテム名|個数|～～～
        // から
        // ----
        // までを抽出
        const startIndex = freeHistoryRows.findIndex(elem => /^@status$/.test(elem));
        if (startIndex === -1)
            return [];
        else
            freeHistoryRows = freeHistoryRows.slice(startIndex + 1);
        const statusList = [];
        freeHistoryRows.forEach(row => {
            if (row.charAt(0) !== '|')
                return;
            const variableTableStatus = row.slice(1).split('|');
            if (variableTableStatus.length < 2)
                return;
            const tableStatus = variableTableStatus.map((elem, index) => {
                // TODO ここらへん全体的に結構無理矢理感ある
                var _a;
                if (index % 3 === 0)
                    return elem;
                // 変数をすべて変換
                (_a = elem.match(/\{(.*?)\}/g)) === null || _a === void 0 ? void 0 : _a.forEach(variable => {
                    elem = elem.replace(variable, this.parseVariable(variable.slice(1, -1)).toString());
                });
                return (0, util_1.calcString)(elem).toString();
            });
            const status = {
                label: tableStatus[0].trim(),
                value: (0, util_1.string2Int)(tableStatus[1]),
                max: !!tableStatus[2] ? (0, util_1.string2Int)(tableStatus[2]) : 0,
            };
            statusList.push(status);
        });
        return statusList;
    }
    convertCommandsResists({ addCommandsShortcut, noStatus, }) {
        const commands = [];
        // 生命抵抗
        const vidResistCommandArray = [];
        vidResistCommandArray.push(`2d`);
        if (noStatus) {
            vidResistCommandArray.push(this.vitResistBase.toString());
            if (this.vitResistAdd > 0)
                vidResistCommandArray.push(this.vitResistAdd.toString());
        }
        else {
            vidResistCommandArray.push(`{${static_1.JobLabel.adventure}}`);
            vidResistCommandArray.push(`(({${static_1.StatusLabel.VIT}})/6)`);
            vidResistCommandArray.push(`${this.vitResistAdd}`);
            vidResistCommandArray.push(`{${static_1.BuffLabel.VIT_RESIST}}`);
            vidResistCommandArray.push(`{${static_1.BuffLabel.ALL}}`);
        }
        if (addCommandsShortcut)
            commands.push(`${vidResistCommandArray.join('+')} 【生命抵抗判定】@${static_1.CommandShortcut.DEFENCE}`);
        else
            commands.push(`${vidResistCommandArray.join('+')} 【生命抵抗判定】`);
        // 精神抵抗
        const mndResistCommandArray = [];
        mndResistCommandArray.push(`2d`);
        if (noStatus) {
            mndResistCommandArray.push(this.mndResistBase.toString());
            mndResistCommandArray.push(this.mndResistAdd.toString());
        }
        else {
            mndResistCommandArray.push(`{${static_1.JobLabel.adventure}}`);
            mndResistCommandArray.push(`(({${static_1.StatusLabel.MND}})/6)`);
            mndResistCommandArray.push(`${this.mndResistAdd}`);
            mndResistCommandArray.push(`{${static_1.BuffLabel.MND_RESIST}}`);
            mndResistCommandArray.push(`{${static_1.BuffLabel.ALL}}`);
        }
        if (addCommandsShortcut)
            commands.push(`${mndResistCommandArray.join('+')} 【精神抵抗判定】@${static_1.CommandShortcut.DEFENCE}`);
        else
            commands.push(`${mndResistCommandArray.join('+')} 【精神抵抗判定】`);
        // 生死抵抗
        const savingCommandArray = [];
        savingCommandArray.push(`2d`);
        if (noStatus) {
            savingCommandArray.push(String(this.level.adventure + this.status.getStatusBonusValue(static_1.StatusLabel.VIT)));
        }
        else {
            savingCommandArray.push(`{${static_1.JobLabel.adventure}}`);
            savingCommandArray.push(`(({${static_1.StatusLabel.VIT}})/6)`);
            savingCommandArray.push(`{${static_1.BuffLabel.ALL}}`);
        }
        if (addCommandsShortcut)
            commands.push(`${savingCommandArray.join('+')} 【生死判定】@${static_1.CommandShortcut.DEFENCE}`);
        else
            commands.push(`${savingCommandArray.join('+')} 【生死判定】`);
        return commands;
    }
    parseVariable(variable) {
        var _a;
        if ((_a = this.items.value) === null || _a === void 0 ? void 0 : _a.some(item => item.name === variable)) {
            const targetItem = this.items.value.find(item => item.name === variable);
            return targetItem != null ? targetItem.num : NaN;
        }
        return this.materialCard.getCards(variable);
    }
}
exports.CharacterSW25 = CharacterSW25;
class StatusSW25 {
    constructor(dex, agi, str, vit, int, mnd) {
        this.dexAdd = 0; // sttAddA
        this.agiAdd = 0; // sttAddB
        this.strAdd = 0; // sttAddC
        this.vitAdd = 0; // sttAddD
        this.intAdd = 0; // sttAddE
        this.mndAdd = 0; // sttAddF
        this.dex = dex; // 器用
        this.agi = agi; // 敏捷
        this.str = str; // 筋力
        this.vit = vit; // 生命
        this.int = int; // 知力
        this.mnd = mnd; // 精神
    }
    generateParams() {
        const params = [
            {
                label: '《ステータス》',
                value: '',
            },
            {
                label: static_1.StatusLabel.DEX,
                value: this.getParamValue(this.dex, this.dexAdd),
            },
            {
                label: static_1.StatusLabel.AGI,
                value: this.getParamValue(this.agi, this.agiAdd),
            },
            {
                label: static_1.StatusLabel.STR,
                value: this.getParamValue(this.str, this.strAdd),
            },
            {
                label: static_1.StatusLabel.VIT,
                value: this.getParamValue(this.vit, this.vitAdd),
            },
            {
                label: static_1.StatusLabel.INT,
                value: this.getParamValue(this.int, this.intAdd),
            },
            {
                label: static_1.StatusLabel.MND,
                value: this.getParamValue(this.mnd, this.mndAdd),
            },
        ];
        return params;
    }
    getParamValue(base, add) {
        if (!!add) {
            if (add > 0)
                return base + '+' + add;
            else
                return base + '-' + -add;
        }
        else {
            return base.toString();
        }
    }
    getStatusFromLabel(status) {
        if (status === static_1.StatusLabel.DEX)
            return this.dex + this.dexAdd;
        if (status === static_1.StatusLabel.AGI)
            return this.agi + this.agiAdd;
        if (status === static_1.StatusLabel.STR)
            return this.str + this.strAdd;
        if (status === static_1.StatusLabel.VIT)
            return this.vit + this.vitAdd;
        if (status === static_1.StatusLabel.INT)
            return this.int + this.intAdd;
        if (status === static_1.StatusLabel.MND)
            return this.mnd + this.mndAdd;
        else
            return 0;
    }
    getStatusBonusValue(status) {
        return Math.floor(this.getStatusFromLabel(status) / 6);
    }
}
class LevelJobSW25 {
    constructor() {
        this.adventure = 0; // 冒険者
        this.fighter = 0; // ファイター
        this.grappler = 0; // グラップラー
        this.battledancer = 0; // バトルダンサー
        this.fencer = 0; // フェンサー
        this.shooter = 0; // シューター
        this.sorcerer = 0; // ソーサラー
        this.conjurer = 0; // コンジャラー
        this.priest = 0; // プリースト
        this.fairytamer = 0; // フェアリーテイマー
        this.magitech = 0; // マギテック
        this.scout = 0; // スカウト
        this.ranger = 0; // レンジャー
        this.sage = 0; // セージ
        this.enhancer = 0; // エンハンサー
        this.bard = 0; // バード
        this.rider = 0; // ライダー
        this.alchemist = 0; // アルケミスト
        this.druid = 0; // ドルイド
        this.demonruler = 0; // デーモンルーラー
        this.wizard = 0; // ウィザード
        this.geomancer = 0; // ジオマンサー
        this.warleader = 0; // ウォーリーダー
        // 以下SW2.0（未対応）
        this.mystic = 0; // ミスティック
        this.phigicalmaster = 0; // フィジカルマスター
        this.grimoire = 0; // グリモワール
        this.aristocracy = 0; // アリストクラシー
        this.artisan = 0; // アーティザン
    }
    getLevelFromJobLabel(jobLabel) {
        if (jobLabel === static_1.JobLabel.adventure)
            return this.adventure;
        if (jobLabel === static_1.JobLabel.fighter)
            return this.fighter;
        if (jobLabel === static_1.JobLabel.grappler)
            return this.grappler;
        if (jobLabel === static_1.JobLabel.battledancer)
            return this.battledancer;
        if (jobLabel === static_1.JobLabel.fencer)
            return this.fencer;
        if (jobLabel === static_1.JobLabel.shooter)
            return this.shooter;
        if (jobLabel === static_1.JobLabel.sorcerer)
            return this.sorcerer;
        if (jobLabel === static_1.JobLabel.conjurer)
            return this.conjurer;
        if (jobLabel === static_1.JobLabel.priest)
            return this.priest;
        if (jobLabel === static_1.JobLabel.fairytamer)
            return this.fairytamer;
        if (jobLabel === static_1.JobLabel.magitech)
            return this.magitech;
        if (jobLabel === static_1.JobLabel.scout)
            return this.scout;
        if (jobLabel === static_1.JobLabel.ranger)
            return this.ranger;
        if (jobLabel === static_1.JobLabel.sage)
            return this.sage;
        if (jobLabel === static_1.JobLabel.enhancer)
            return this.enhancer;
        if (jobLabel === static_1.JobLabel.bard)
            return this.bard;
        if (jobLabel === static_1.JobLabel.rider)
            return this.rider;
        if (jobLabel === static_1.JobLabel.alchemist)
            return this.alchemist;
        if (jobLabel === static_1.JobLabel.druid)
            return this.druid;
        if (jobLabel === static_1.JobLabel.demonruler)
            return this.demonruler;
        if (jobLabel === static_1.JobLabel.wizard)
            return this.wizard;
        if (jobLabel === static_1.JobLabel.geomancer)
            return this.geomancer;
        if (jobLabel === static_1.JobLabel.warleader)
            return this.warleader;
        if (jobLabel === static_1.JobLabel.mystic)
            return this.mystic;
        if (jobLabel === static_1.JobLabel.phigicalmaster)
            return this.phigicalmaster;
        if (jobLabel === static_1.JobLabel.grimoire)
            return this.grimoire;
        if (jobLabel === static_1.JobLabel.aristocracy)
            return this.aristocracy;
        if (jobLabel === static_1.JobLabel.artisan)
            return this.artisan;
        return 0;
    }
    generateParams() {
        let params = [];
        params.push({ label: '《技能》', value: '' });
        params = Object.entries(this)
            .map(([label, value]) => ({ label, value }))
            .filter(({ label, value }) => (value > 0))
            .sort((a, b) => (b.value - a.value))
            .map(beforeParam => {
            return {
                label: static_1.JobLabel[beforeParam.label],
                value: beforeParam.value.toString(),
            };
        });
        return params;
    }
}
class DecisionAddPackage {
    constructor() {
        this.scoutPackage = {
            tec: 0,
            agi: 0,
            obs: 0,
        };
        this.rangerPackage = {
            tec: 0,
            agi: 0,
            obs: 0,
        };
        this.sagePackage = {
            kno: 0,
        };
        this.riderPackage = {
            agi: 0,
            obs: 0,
            kno: 0,
        };
        this.alchemistPackage = {
            kno: 0,
        };
        this.bardPackage = {
            kno: 0,
        };
        this.warleaderPackage = {
            agi: 0,
            int: 0,
        };
        this.geomancerPackage = {
            obs: 0,
        };
        this.monsterLore = 0; // 魔物知識
        this.initiative = 0; // 先制
    }
}
class MagicPower {
    constructor() {
        this.power = {
            sorcerer: 0,
            conjurer: 0,
            wizard: 0,
            priest: 0,
            fairytamer: 0,
            magitech: 0,
            bard: 0,
            druid: 0,
            demonruler: 0, // デーモンルーラー
        };
        this.cast = {
            sorcerer: 0,
            conjurer: 0,
            wizard: 0,
            priest: 0,
            fairytamer: 0,
            magitech: 0,
            druid: 0,
            demonruler: 0,
            bard: 0,
            alchemist: 0, // アルケミスト
        };
        this.damage = {
            sorcerer: 0,
            conjurer: 0,
            wizard: 0,
            priest: 0,
            fairytamer: 0,
            magitech: 0,
            druid: 0,
            demonruler: 0,
            bard: 0, // バード
        };
        this.isOwn = {
            sorcerer: false,
            conjurer: false,
            wizard: false,
            priest: false,
            fairytamer: false,
            magitech: false,
            druid: false,
            demonruler: false,
            bard: false,
            alchemist: false, // アルケミスト
        };
    }
}
class Weapon {
    constructor() {
        this.name = ''; // 武器名
        this.usage = ''; // 用法
        this.reqstr = 0; // 必筋
        this.acc = 0; // 命中補正
        this.rate = 0; // 威力
        this.crit = 13; // C値
        this.dmg = 0; // 追加D
        this.own = false; // 専用化している？
        this.category = ''; // 武器カテゴリ
        this.cls = ''; // 扱う技能
        this.accTotal = 0; // 命中合算(命中強化を含む)
        this.dmgTotal = 0; // ダメージ合算(クロスボウ考慮済み)
    }
    getUsageAndName() {
        if (!!this.usage)
            return this.usage + '〈' + this.name + '〉';
        else
            return `〈${this.name}〉`;
    }
    convertCommandsAccracy(combatFeats, addCommandsShortcut, noStatus) {
        const BUFF_ALL = `{${static_1.BuffLabel.ALL}}`;
        const BUFF_ACT = `{${static_1.BuffLabel.ACT}}`;
        const BUFF_ACC = `{${static_1.BuffLabel.ACC}}`;
        const STATUS_DEX = `{${static_1.StatusLabel.DEX}}`;
        const command = [];
        command.push(`2d`);
        if (noStatus) {
            command.push(this.accTotal.toString());
        }
        else {
            if (this.cls) {
                command.push(`{${this.cls}}`);
                if (this.own)
                    command.push(`((${STATUS_DEX}+2)/6)`);
                else
                    command.push(`((${STATUS_DEX})/6)`);
            }
            if (combatFeats.some(elem => elem === Weapon.ACCRACY_BOOST_2))
                command.push('2');
            else if (combatFeats.some(elem => elem === Weapon.ACCRACY_BOOST_1))
                command.push('1');
            if (this.acc != 0)
                command.push(this.acc.toString());
            command.push(BUFF_ACC);
            command.push(BUFF_ACT);
            command.push(BUFF_ALL);
        }
        if (addCommandsShortcut) {
            return `${command.join('+')} 【命中力判定/${this.getUsageAndName()}】@${static_1.CommandShortcut.ATTACK}`;
        }
        else {
            return `${command.join('+')} 【命中力判定/${this.getUsageAndName()}】`;
        }
    }
    convertCommandsDamage(combatFeats, addCommandsShortcut, noStatus) {
        const BUFF_ALL = '{' + static_1.BuffLabel.ALL + '}';
        const BUFF_ACT = '{' + static_1.BuffLabel.ACT + '}';
        const BUFF_PHG_DAMAGE = '{' + static_1.BuffLabel.PHG_DAMAGE + '}';
        // const BUFF_PHG_CRITCAL  : string = '{' + BuffLabel.PHG_CRITCAL + '}';
        const STATUS_STR = '{' + static_1.StatusLabel.STR + '}';
        const commands = [];
        if (this.category === 'ガン') {
            return commands;
        }
        const command = [];
        // command.push('k'+this.rate+'[('+this.crit+'+'+BUFF_PHG_CRITCAL+')]');
        command.push(`k${this.rate}[${this.crit}]`);
        if (noStatus) {
            command.push(this.dmgTotal.toString());
        }
        else {
            if (this.cls) {
                command.push(`{${this.cls}}`);
                if (this.category !== 'クロスボウ')
                    command.push(`((${STATUS_STR})/6)`);
            }
            if (combatFeats.some(elem => elem === Weapon.WEAPON_MASTER_S + this.category))
                command.push('3');
            else if (combatFeats.some(elem => elem === Weapon.WEAPON_MASTER_A + this.category))
                command.push('1');
            if (this.dmg !== undefined && this.dmg != 0)
                command.push(this.dmg.toString());
            command.push(BUFF_PHG_DAMAGE);
        }
        if (addCommandsShortcut)
            commands.push(`${command.join('+')} 【ダメージ/${this.getUsageAndName()}】@${static_1.CommandShortcut.ATTACK}`);
        else
            commands.push(`${command.join('+')} 【ダメージ/${this.getUsageAndName()}】`);
        const critCommand = command.concat();
        critCommand[0] = (`k${this.rate}[${this.crit}]$+1`);
        // 一旦消しておく
        // commands.push(`${critCommand.join('+')} 【ダメージ/${this.getUsageAndName()}クリレイ】@${CommandShortcut.ATTACK}`);
        if (combatFeats.some(elem => /必殺攻撃.+/.test(elem))) {
            const specialCommand = command.concat();
            specialCommand[0] = (`k${this.rate}[${this.crit}]#1`);
            if (addCommandsShortcut)
                commands.push(`${specialCommand.join('+')} 【ダメージ/${this.getUsageAndName()}必殺攻撃】@${static_1.CommandShortcut.ATTACK}`);
            else
                commands.push(`${specialCommand.join('+')} 【ダメージ/${this.getUsageAndName()}必殺攻撃】`);
            const specialCritCommand = command.concat();
            specialCritCommand[0] = (`k${this.rate}[${this.crit}]$+1#1`);
            if (addCommandsShortcut)
                commands.push(`${specialCritCommand.join('+')} 【ダメージ/${this.getUsageAndName()}クリレイ+必殺攻撃】@${static_1.CommandShortcut.ATTACK}`);
            else
                commands.push(`${specialCritCommand.join('+')} 【ダメージ/${this.getUsageAndName()}クリレイ+必殺攻撃】`);
        }
        return commands;
    }
}
Weapon.WEAPON_MASTER_A = '武器習熟Ａ／';
Weapon.WEAPON_MASTER_S = '武器習熟Ｓ／';
Weapon.ACCRACY_BOOST_1 = '命中強化Ⅰ';
Weapon.ACCRACY_BOOST_2 = '命中強化Ⅱ';
class MaterialCard {
    constructor() {
        this.red = new CardRanks();
        this.green = new CardRanks();
        this.black = new CardRanks();
        this.white = new CardRanks();
        this.gold = new CardRanks();
    }
    generateParams() {
        const params = [];
        params.push({ label: '《マテリアルカード》', value: '' });
        if (this.red.b > 0)
            params.push({ label: '赤B', value: this.red.b.toString() });
        if (this.red.a > 0)
            params.push({ label: '赤A', value: this.red.a.toString() });
        if (this.red.s > 0)
            params.push({ label: '赤S', value: this.red.s.toString() });
        if (this.red.ss > 0)
            params.push({ label: '赤SS', value: this.red.ss.toString() });
        if (this.green.b > 0)
            params.push({ label: '緑B', value: this.green.b.toString() });
        if (this.green.a > 0)
            params.push({ label: '緑A', value: this.green.a.toString() });
        if (this.green.s > 0)
            params.push({ label: '緑S', value: this.green.s.toString() });
        if (this.green.ss > 0)
            params.push({ label: '緑SS', value: this.green.ss.toString() });
        if (this.black.b > 0)
            params.push({ label: '黒B', value: this.black.b.toString() });
        if (this.black.a > 0)
            params.push({ label: '黒A', value: this.black.a.toString() });
        if (this.black.s > 0)
            params.push({ label: '黒S', value: this.black.s.toString() });
        if (this.black.ss > 0)
            params.push({ label: '黒SS', value: this.black.ss.toString() });
        if (this.white.b > 0)
            params.push({ label: '白B', value: this.white.b.toString() });
        if (this.white.a > 0)
            params.push({ label: '白A', value: this.white.a.toString() });
        if (this.white.s > 0)
            params.push({ label: '白S', value: this.white.s.toString() });
        if (this.white.ss > 0)
            params.push({ label: '白SS', value: this.white.ss.toString() });
        if (this.gold.b > 0)
            params.push({ label: '金B', value: this.gold.b.toString() });
        if (this.gold.a > 0)
            params.push({ label: '金A', value: this.gold.a.toString() });
        if (this.gold.s > 0)
            params.push({ label: '金S', value: this.gold.s.toString() });
        if (this.gold.ss > 0)
            params.push({ label: '金SS', value: this.gold.ss.toString() });
        return params.length === 1 ? [] : params; // マテリアルカードが無いなら見出しを表示しない
    }
    getCards(label) {
        if (label.length > 3)
            return 0;
        if (label.charAt(0) === '赤') {
            if (label.charAt(1).toLowerCase() === 'b')
                return this.red.b;
            if (label.charAt(1).toLowerCase() === 'a')
                return this.red.a;
            if (label.charAt(1).toLowerCase() === 's')
                return this.red.s;
            if (label.charAt(1).toLowerCase() === 'ss')
                return this.red.ss;
        }
        else if (label.charAt(0) === '緑') {
            if (label.charAt(1).toLowerCase() === 'b')
                return this.green.b;
            if (label.charAt(1).toLowerCase() === 'a')
                return this.green.a;
            if (label.charAt(1).toLowerCase() === 's')
                return this.green.s;
            if (label.charAt(1).toLowerCase() === 'ss')
                return this.green.ss;
        }
        else if (label.charAt(0) === '黒') {
            if (label.charAt(1).toLowerCase() === 'b')
                return this.black.b;
            if (label.charAt(1).toLowerCase() === 'a')
                return this.black.a;
            if (label.charAt(1).toLowerCase() === 's')
                return this.black.s;
            if (label.charAt(1).toLowerCase() === 'ss')
                return this.black.ss;
        }
        else if (label.charAt(0) === '白') {
            if (label.charAt(1).toLowerCase() === 'b')
                return this.white.b;
            if (label.charAt(1).toLowerCase() === 'a')
                return this.white.a;
            if (label.charAt(1).toLowerCase() === 's')
                return this.white.s;
            if (label.charAt(1).toLowerCase() === 'ss')
                return this.white.ss;
        }
        else if (label.charAt(0) === '金') {
            if (label.charAt(1).toLowerCase() === 'b')
                return this.gold.b;
            if (label.charAt(1).toLowerCase() === 'a')
                return this.gold.a;
            if (label.charAt(1).toLowerCase() === 's')
                return this.gold.s;
            if (label.charAt(1).toLowerCase() === 'ss')
                return this.gold.ss;
        }
        return 0;
    }
}
class CardRanks {
    constructor() {
        this.ss = 0;
        this.s = 0;
        this.a = 0;
        this.b = 0;
    }
}
class Item {
    constructor() {
        this.name = '';
        this.num = 0;
    }
    static convertItemsFromYutorizeTable(yutorizeTable) {
        // 整形
        let tableItems = yutorizeTable.split('<br>');
        // |アイテム名|個数|～～～
        // から
        // ----
        // までを抽出
        const startIndex = tableItems.findIndex(elem => /^\|アイテム名\|個数\|.*$/.test(elem));
        const endIndex = tableItems.findIndex(elem => /^\-\-\-\-$/.test(elem));
        if (startIndex > -1 && endIndex > -1 && endIndex < startIndex) {
            throw new Error('所持品入力形式が不正です');
        }
        if (startIndex === -1)
            return new Items([]);
        else if (endIndex > -1)
            tableItems = tableItems.slice(startIndex + 1, endIndex);
        else
            tableItems = tableItems.slice(startIndex + 1);
        const items = [];
        tableItems.forEach(row => {
            if (row.charAt(0) !== '|')
                return;
            const tableItem = row.slice(1).split('|');
            if (tableItem.length < 2)
                return;
            const item = new Item();
            item.name = tableItem[0];
            item.num = (0, util_1.string2Int)(tableItem[1]);
            items.push(item);
        });
        return new Items(items);
    }
}
class Items {
    constructor(value) {
        this.value = [];
        this.value = value;
    }
    generateParams() {
        const params = [];
        params.push({ label: '《アイテム》', value: '' });
        this.value.forEach(item => params.push({ label: item.name, value: item.num.toString() }));
        return params;
    }
}
//# sourceMappingURL=chara.js.map